import FlowsPageView from "./FlowsPageView";

function FlowsPage() {
  return <FlowsPageView />;
}

export default FlowsPage;
